import api from './config';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  profile: null,
  loading: false,
  error: ''
};

// Public endpoint — no auth required. Feeds the footer's contact info, addresses,
// phone numbers and social links so they stay in sync with the super admin panel.
export const fetchOrganizationProfile = createAsyncThunk(
  'organization/fetchOrganizationProfile',
  async (_, { rejectWithValue }) => {
    try {
      // Cache-bust: the endpoint returns an ETag but no Cache-Control, so browsers can
      // serve a stale cached copy on repeat visits without ever hitting the network.
      const response = await api.get('/organization/public', {
        params: { _: Date.now() },
        headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' }
      });
      return response.data;
    } catch (error) {
      if (!error.response) throw error;
      return rejectWithValue(error.response.data);
    }
  }
);

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationProfile.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchOrganizationProfile.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.profile = payload;
      })
      .addCase(fetchOrganizationProfile.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload?.message || 'Erreur lors du chargement des informations de la société';
      });
  }
});

export default organizationSlice.reducer;
